const FEATURESTATE_ENUM = {
  UPCOMING: 'UPCOMING',
  BETA: 'BETA',
  NEW_RELEASED: 'NEW_RELEASED',
  RELEASED: 'RELEASED'
};

export { FEATURESTATE_ENUM };
